<template>
  <div class="common_swiper_main">
    <div class="common_swiper_vantswiper">
      <van-swipe
        ref="swiper"
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item
          v-for="item in article_info.coverImagesList"
          :key="item.url"
        >
          <a
            :href="item.des ?? 'javascript:void(0);'"
            class="common_swiper_link"
          >
            <van-image
              width="100%"
              height="6rem"
              fit="cover"
              :src="item.url"
              :alt="article_info.title"
              radius="5px"
            />
          </a>
          <a :href="item.des ?? 'javascript:void(0);'"></a>
        </van-swipe-item>
      </van-swipe>
    </div>

    
  </div>
</template>

<script>
import { ref, onMounted, nextTick, computed, toRef } from "vue";

export default {
  props: {
    article_info: Object,
  },
  setup() {
    // 获取swiper
    const swiper = ref(null);

    onMounted(() => {
      nextTick(() => {
        swiper.value.resize();
      });
    });

    return {
      swiper,
    };
  },
};
</script>

<style>
.my-swipe .van-swipe-item {
}

.common_swiper_vantswiper {
  width: 96%;
  margin: 0 auto;
  overflow: hidden;
}

.my-swipe {
  width: 100%;
}

.van-swipe__indicators {
  left: auto;
  right: 5%;
  transform: translateX(0%);
}

.common_swiper_link {
  display: block;
  width: 99%;
  margin: 0 auto;
}
</style>